const state= {
    header_item: {}
};

const getters = {
    headerItem : (state) => state.header_item,
};

const actions = {
    // Budget Header
    async getHeaderItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/budget-headers`, {params:params})
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async getHeaderItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/budget-headers/${params}`)
            .then(response => {
                commit( 'setHeaderItem', response.data.data );
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async addHeaderItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/budget-headers`, params)
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async updateHeaderItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`api/budget-headers/${params.id}`, params)
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async cloneHeaderItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/budget-headers/clone`, params)
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async deleteHeaderItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/budget-headers`, {
                data: {
                    ids: params
                }
            })
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    // Budget Entries
    async getBudgetEntries({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`/api/budget-entries`, {params:params})
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async addBudgetEntries({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`/api/budget-entries`, params)
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async updateBudgetEntries({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`/api/budget-entries`, params)
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async deleteBudgetEntries({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`/api/budget-entries`, {
                data: {
                    ids: params
                }
            })
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    // Budget Entries - Tracking
    async getBudgetTrackingEntries({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`/api/budget-entries/tracking`, {params:params})
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    // Budget Entries - Tracking Detail
    async getBudgetTrackingDetailEntries({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`/api/budget-tracking-detail`, {params:params})
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    // Budget Export
    async exportBudgetHeader({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`/api/budget-headers/export`, params)
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async exportBudgetEntries({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`/api/budget-entries/export`, {params:params})
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
};

const mutations = {
    setHeaderItem (state, data) {
        state.header_item = data
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
